'use client'

import { lazy, Suspense } from 'react'

import styles from '@/app/style-guide/hearing-aids-hub/guide.module.css'
import { useTranslation } from '@/hooks/client/use-translation'

// UsVisitorsOnly mounts this tool only after its existing eligibility check.
// Load the conversation code at that point rather than on every hub visit.
const AdvisorChat = lazy(() =>
  import('@/components/client/advisor/advisor-chat').then((module) => ({ default: module.AdvisorChat }))
)

export const HearingGuideTool = ({ available, buildVersion }: { available: boolean; buildVersion?: string }) => {
  const { t } = useTranslation()
  return (
    <div id="hearing-guide-chat" className={styles.tool} data-hub-shared>
      <Suspense
        fallback={
          <p className="min-h-96 py-8" role="status">
            {t('app.loading', 'Loading...')}
          </p>
        }
      >
        <AdvisorChat variant="hub" enabled={available} buildVersion={buildVersion} />
      </Suspense>
    </div>
  )
}
